import { AddCircle, Close } from "@mui/icons-material";
import { Box, IconButton, Tooltip, CircularProgress } from "@mui/material";
import CalendarGoogleIcon from "@/assets/CalendarGoogleIcon.png";

interface GoogleCalendarButtonProps {
  isInCalendar: boolean;
  onAddToCalendar: () => void;
  onRemoveFromCalendar: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const GoogleCalendarButton = ({
  isInCalendar,
  onAddToCalendar,
  onRemoveFromCalendar,
  disabled = false,
  loading = false,
}: GoogleCalendarButtonProps) => {
  return (
    <Tooltip title={isInCalendar ? "Remover do Google Calendar" : "Adicionar ao Google Calendar"}>
      <span>
        <IconButton
          disabled={disabled || loading}
          onClick={isInCalendar ? onRemoveFromCalendar : onAddToCalendar}
          sx={{
            position: 'relative',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <Box position="relative" display="flex" alignItems="center">
            {loading ? (
              <CircularProgress size={24} thickness={5} />
            ) : (
              <>
                <Box
                  component="img"
                  src={CalendarGoogleIcon}
                  alt="Google Calendar"
                  sx={{
                    width: 22,
                    height: 22,
                    objectFit: 'contain',
                    opacity: isInCalendar ? 0.7 : 1,
                  }}
                />
                {isInCalendar ? (
                  <Close
                    sx={{
                      position: 'absolute',
                      top: -4,
                      right: -4,
                      fontSize: 12,
                      color: 'error.main',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                    }}
                  />
                ) : (
                  <AddCircle
                    sx={{
                      position: 'absolute',
                      top: -4,
                      right: -4,
                      fontSize: 12,
                      color: 'success.main',
                    }}
                  />
                )}
              </>
            )}
          </Box>
        </IconButton>
      </span>
    </Tooltip>
  );
}; 